import { trace } from 'rytm-helpers'
import Controller from './Controller'
import Pizzicato from 'pizzicato'
import { destroyPlayground, initPlayground, stopPlayground } from '../playground'
// import playgroundController from '../playground/controllers/PlaygroundController'
// import { settings, setup } from './../playground/config'

let anyInteractionOccured = false

class HomePlayController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    if (anyInteractionOccured) {
      document.body.classList.add('user-interaction')
      initPlayground()
    }
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e) 
    destroyPlayground()
    document.documentElement.classList.remove('playground-menu-open')
    document.body.classList.remove('user-interaction')
  }
  addEventListeners() {
    super.addEventListeners()
    $("body").on("touchstart click", ".editionhome-playground-intro", $.proxy(this.onUserInteraction, this))
    $("body").on("keydown", $.proxy(this.onUserInteraction, this))
    // controls
    $("body").on("click", ".playground-menu-expand", $.proxy(this.onMenuExpand, this))
    $("body").on("click", ".playground-menu-close", $.proxy(this.onMenuClose, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    $("body").off("touchstart click", ".editionhome-playground-intro", $.proxy(this.onUserInteraction, this))
    $("body").off("keydown", $.proxy(this.onUserInteraction, this))
    stopPlayground()
    // controls
    $("body").off("click", ".playground-menu-expand", $.proxy(this.onMenuExpand, this))
    $("body").off("click", ".playground-menu-close", $.proxy(this.onMenuClose, this))
  }
  /**
   * ###########
   * ### OWN ###
   */
   onUserInteraction(e) {
    $("body").off("click", ".editionhome-playground-intro", $.proxy(this.onUserInteraction, this))
    $("body").off("keydown", $.proxy(this.onUserInteraction, this))
    if (!anyInteractionOccured) {
      this.startPizzicatoPlayback()
      anyInteractionOccured = true
      document.body.classList.add('user-interaction')
      initPlayground()
    }
  }
  onMenuExpand(e) {
    e.preventDefault()
    e.stopPropagation()
    document.documentElement.classList.add('playground-menu-open')
  }
  onMenuClose(e) {
    e.preventDefault()
    e.stopPropagation()
    document.documentElement.classList.remove('playground-menu-open')
  }
  /**
   * Fix for Safari webbrowser
   * needed to play any loaded audio blob...
   */
   startPizzicatoPlayback() {
    trace("start pizzicato")
    let context = Pizzicato.context
    let source = context.createBufferSource()
    source.buffer = context.createBuffer(1, 1, 22050)
    source.connect(context.destination)
    source.start()
  }
   
}

export default HomePlayController;